import React from "react";
import { Check } from "lucide-react";
import { cn } from "@/lib/utils";

interface StepIndicatorProps {
    currentStep: number;
    totalSteps: number;
}

/**
 * Thanh chỉ báo bước hiện tại trong quy trình đặt phòng (1 → 2 → 3)
 */
export const StepIndicator: React.FC<StepIndicatorProps> = ({ currentStep }) => {
    const steps = [
        { num: 1, label: "Chọn phòng" },
        { num: 2, label: "Thông tin" },
        { num: 3, label: "Thanh toán" },
    ];

    return (
        <div className="flex items-center gap-1">
            {steps.map((step, idx) => (
                <React.Fragment key={step.num}>
                    <div className="flex items-center gap-1.5">
                        <div
                            className={cn(
                                "w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold transition-all",
                                currentStep >= step.num
                                    ? "bg-primary text-primary-foreground"
                                    : "bg-muted text-muted-foreground",
                            )}
                        >
                            {currentStep > step.num ? (
                                <Check className="w-3.5 h-3.5" strokeWidth={3} />
                            ) : (
                                step.num
                            )}
                        </div>
                        <span
                            className={cn(
                                "text-xs font-medium hidden md:block",
                                currentStep >= step.num ? "text-primary" : "text-muted-foreground",
                            )}
                        >
                            {step.label}
                        </span>
                    </div>
                    {idx < steps.length - 1 && (
                        <div
                            className={cn(
                                "w-6 h-0.5 mx-1",
                                currentStep > step.num ? "bg-primary" : "bg-muted",
                            )}
                        />
                    )}
                </React.Fragment>
            ))}
        </div>
    );
};
